import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import { isAuthenticated } from '../../../../services/auth';
import { message } from 'antd';
import { getLocation, editLocation } from '../../../../services/admin';
import UnifiedDashboard from '../../../../components/layout/UnifiedDashboard';
import './EditLocation.css';

const EditLocation = ({ match }) => {
  const [name, setName] = useState('');
  const { token } = isAuthenticated();
  const history = useHistory();

  useEffect(() => {
    const loadLocation = async () => {
      const data = await getLocation(match.params.locationId);
      setName(data.data.name);
    };

    if (match.params.locationId) {
      loadLocation();
    }
  }, [match.params.locationId]);

  const handleChange = (e) => {
    setName(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await editLocation(match.params.locationId, { name, token });
      message.success('Localização editada com sucesso', 4);
      history.push('/admin/add-location');
    } catch (err) {
      if (err.response?.status === 400) message.error(err.response.data, 4);
    }
  };

  return (
    <UnifiedDashboard title="Editar Localização">
      <div className='edit-location-container'>
        <div className='edit-location-header'>
          <button
            className='edit-location-back-btn'
            onClick={() => history.push('/admin/add-location')}
            title='Voltar'
          >
            <i className='fas fa-arrow-left'></i>
          </button>
          <div>
            <h1 className='edit-location-title'>
              <i className='fas fa-edit'></i>
              Editar Localização
            </h1>
            <p className='edit-location-subtitle'>Altere os dados da localização</p>
          </div>
        </div>

        <div className='edit-location-card'>
          <form onSubmit={handleSubmit} className='edit-location-form'>
            <div className='edit-location-form-group'>
              <label className='edit-location-label'>
                <i className='fas fa-map-pin'></i>
                Nome da Localização
              </label>
              <input
                type='text'
                className='edit-location-input'
                placeholder='Digite o novo nome da localização'
                value={name}
                onChange={handleChange}
                required
              />
            </div>
            <button type='submit' className='edit-location-submit-btn'>
              <i className='fas fa-save'></i>
              Salvar Alterações
            </button>
          </form>
        </div>
      </div>
    </UnifiedDashboard>
  );
};

export default EditLocation;
